<template>
  <td class="pr-4">
    <h6 class="custom-margin-h6-table">
      <strong>{{ $t('common_words.contacts') }}:</strong>
    </h6>
    <span
      v-for="(contact, index) in provider_contacts"
      :key="index"
      class="mb-2"
    >
      <el-tag style="height: auto; color: black; width: 100%" type="info">
        <div class="row pt-2">
          <div class="col-12 col-sm-6 col-md-6 col-xl-4">
            <h6 class="mb-2">
              <strong>{{ $t('common_words.email') }}</strong>
            </h6>
            <p>
              {{
                model.email[index]
                  ? model.email[index]
                  : $t('common_words.no_assignment')
              }}
            </p>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-xl-4">
            <h6 class="mb-2">
              <strong>{{ $t('inventory.email_type') }}</strong>
            </h6>
            <div v-for="(emailType, i) in model.type[index]" :key="i">
              <p>
                {{
                  `*${
                    emailType ? emailType : $t('common_words.no_assignment')
                  } `
                }}
              </p>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-xl-4">
            <h6 class="mb-2">
              <strong>{{ $t('common_words.phone') }}</strong>
            </h6>
            <p>
              {{
                model.phone[index]
                  ? model.phone[index]
                  : $t('common_words.no_assignment')
              }}
            </p>
          </div>
        </div>
      </el-tag>
    </span>
  </td>
</template>
<script>
export default {
  name: 'info-contacts',
  props: {
    provider_contacts: {
      type: Array,
      default: () => [],
    },
    model: {
      type: Object,
      required: true,
    },
  },
};
</script>
